export const sortStrings = (_a, _b) => {
  const a = _a.name.toLocaleLowerCase();
  const b = _b.name.toLocaleLowerCase();

  if (a < b) { return -1; }
  if (a > b) { return 1; }
  return 0;
};
